<template>
  <div class="blog-index">
    <h1 class="blog-index__title">Blog CRA Freelance</h1>
    <p class="blog-index__subtitle">
      Conseils et guides pratiques pour les freelances en régie : CRA, validation client, gestion administrative.
    </p>
    <div class="blog-index__articles">
      <article
        v-for="article in articles"
        :key="article.path"
        class="blog-index__articles__card"
      >
        <NuxtLink :to="`/blog${article.path}`" class="blog-index__articles__card__link">
          <h2 class="blog-index__articles__card__link__title">{{ article.title }}</h2>
          <p class="blog-index__articles__card__link__description">{{ article.description }}</p>
          <div class="blog-index__articles__card__link__tags" v-if="article.tags">
            <span
              v-for="tag in article.tags"
              :key="tag"
              class="blog-index__articles__card__link__tags__tag"
            >{{ tag }}</span>
          </div>
        </NuxtLink>
      </article>
    </div>
  </div>
</template>

<script setup>
  const { setSeoMeta } = useSeo()

  setSeoMeta({
    title: 'Blog - Conseils CRA et gestion pour Freelances en régie',
    description: 'Guides pratiques sur le CRA, la validation client, la signature électronique et la gestion administrative. Tout ce que les freelances en régie doivent savoir.',
    type: 'website',
    keywords: ['blog freelance', 'conseils CRA', 'CRA freelance', 'gestion administrative', 'freelance en régie', 'validation CRA', 'modèle CRA'],
    breadcrumbs: [
      { name: 'Accueil', url: 'https://cra-freelance.fr' },
      { name: 'Blog', url: 'https://cra-freelance.fr/blog' }
    ]
  })

  definePageMeta({
    layout: 'site'
  })

  const { data: articles } = await useAsyncData('blog-articles', () =>
    queryCollection('content')
      .where('path', '<>', '/')
      .order('datePublished', 'DESC')
      .all()
  )
</script>

<style lang="scss">
  $desktop-breakpoint: 990px;
  $tablet-breakpoint: 672px;

  .blog-index {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 20px;

    &__title {
      color: #01498B;
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 10px;

      @media screen and (min-width: $tablet-breakpoint) {
        font-size: 38px;
      }
    }

    &__subtitle {
      color: #555;
      font-size: 18px;
      font-weight: 300;
      line-height: 28px;
      margin-bottom: 40px;
    }

    &__articles {
      display: flex;
      flex-direction: column;
      gap: 20px;

      &__card {
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        transition: box-shadow 0.2s ease, border-color 0.2s ease;

        &:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border-color: #01498B;
        }

        &__link {
          display: block;
          padding: 24px;
          text-decoration: none;
          color: inherit;

          &__title {
            color: #01498B;
            font-size: 22px;
            font-weight: 500;
            margin: 0 0 8px;
          }

          &__description {
            color: #555;
            font-size: 16px;
            font-weight: 300;
            line-height: 24px;
            margin: 0 0 12px;
          }

          &__tags {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;

            &__tag {
              background-color: #01498B10;
              color: #01498B;
              font-size: 13px;
              padding: 3px 10px;
              border-radius: 12px;
              font-weight: 400;
            }
          }
        }
      }
    }
  }
</style>
